/**
 * URL Configuration for Jiffys Mobile
 * Centralizes all URL routing and ensures consistency across the app
 * 
 * Official Domain: jiffysassistance.site
 */

// Route definitions - maps to all official URLs
export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  APPLY: '/apply',
  MARKETPLACE: '/marketplace',
  
  // Customer routes
  CUSTOMER: '/customer',
  CUSTOMER_REQUEST: '/customer/request',
  CUSTOMER_TRACKING: '/customer/tracking',
  CUSTOMER_HISTORY: '/customer/history',
  
  // Provider routes (mechanics & roadside techs)
  PROVIDER: '/provider',
  PROVIDER_DASHBOARD: '/provider/dashboard',
  PROVIDER_JOB: '/provider/job',
  
  // Legacy mechanic routes (redirect to provider)
  MECHANIC: '/mechanic',
  MECHANIC_JOB: '/mechanic/job',
  
  // Admin routes
  ADMIN: '/admin',
  ADMIN_JOB: '/admin/job',
  
  // Owner routes
  OWNER: '/owner',
  
  // Marketplace routes
  MARKETPLACE_PRODUCT: '/marketplace/product',
  MARKETPLACE_SELL: '/marketplace/sell',
  MARKETPLACE_LISTINGS: '/marketplace/my-listings',
  
  // Utility routes
  SETTINGS: '/settings',
  CART: '/cart',
  PAYMENT_SUCCESS: '/payment/success',
  PENDING_APPROVAL: '/pending-approval',
  
  // Insurance portal
  INSURANCE: '/insurance',
  
  // Advertiser portal
  ADVERTISER_LOGIN: '/advertiser/login',
  ADVERTISER_PORTAL: '/advertiser/portal',
};

// Get the dashboard route based on user type
export const getDashboardRoute = (user) => {
  if (!user) return ROUTES.LOGIN;
  
  if (user.is_owner || user.user_type === 'owner') {
    return ROUTES.OWNER;
  }
  if (user.is_admin || user.user_type === 'admin') {
    return ROUTES.ADMIN;
  }
  if (user.user_type === 'mechanic' || user.user_type === 'roadside_tech') {
    return ROUTES.PROVIDER;
  }
  return ROUTES.CUSTOMER;
};

// Navigation items for each user type
export const getNavigationItems = (user) => {
  if (!user) {
    return [
      { path: ROUTES.HOME, label: 'Home' },
      { path: ROUTES.MARKETPLACE, label: 'Marketplace' },
      { path: ROUTES.LOGIN, label: 'Login' },
    ];
  }
  
  if (user.is_owner || user.user_type === 'owner') {
    return [
      { path: ROUTES.OWNER, label: 'Command Center' },
      { path: ROUTES.ADMIN, label: 'Admin' },
      { path: ROUTES.PROVIDER, label: 'Jobs' },
      { path: ROUTES.MARKETPLACE, label: 'Marketplace' },
      { path: ROUTES.SETTINGS, label: 'Settings' },
    ];
  }
  
  if (user.is_admin || user.user_type === 'admin') {
    return [
      { path: ROUTES.ADMIN, label: 'Dashboard' },
      { path: ROUTES.PROVIDER, label: 'Jobs' },
      { path: ROUTES.MARKETPLACE, label: 'Marketplace' },
      { path: ROUTES.SETTINGS, label: 'Settings' },
    ];
  }
  
  if (user.user_type === 'mechanic' || user.user_type === 'roadside_tech') {
    return [
      { path: ROUTES.PROVIDER, label: 'My Jobs' },
      { path: ROUTES.MECHANIC, label: 'All Jobs' },
      { path: ROUTES.MARKETPLACE, label: 'Marketplace' },
      { path: ROUTES.SETTINGS, label: 'Settings' },
    ];
  }
  
  // Customer
  return [
    { path: ROUTES.CUSTOMER, label: 'Home' },
    { path: ROUTES.CUSTOMER_REQUEST, label: 'Get Help' },
    { path: ROUTES.MARKETPLACE, label: 'Shop' },
    { path: ROUTES.CUSTOMER_HISTORY, label: 'History' },
    { path: ROUTES.SETTINGS, label: 'Profile' },
  ];
};

// Build full URL for sharing/emails
export const buildFullUrl = (path) => {
  // Use official domain for production URLs
  const baseUrl = process.env.NODE_ENV === 'production' 
    ? 'https://jiffysassistance.site'
    : window.location.origin;
  
  return `${baseUrl}${path}`;
};

// Build tracking URL for customer
export const buildTrackingUrl = (requestId) => {
  return buildFullUrl(`${ROUTES.CUSTOMER_TRACKING}/${requestId}`);
};

// Build job detail URL for provider
export const buildJobUrl = (requestId) => {
  return buildFullUrl(`${ROUTES.PROVIDER_JOB}/${requestId}`);
};

// Build product URL for marketplace
export const buildProductUrl = (productId) => {
  return buildFullUrl(`${ROUTES.MARKETPLACE_PRODUCT}/${productId}`);
};

// Contact info
export const CONTACT = {
  PHONE: '2602183536',
  PHONE_FORMATTED: '(260) 218-3536',
  EMAIL: 'zachary@jiffysassistance.site',
  DOMAIN: 'jiffysassistance.site',
};

// Social media / external links
export const EXTERNAL_LINKS = {
  SUPPORT_EMAIL: `mailto:${CONTACT.EMAIL}`,
  EMERGENCY_CALL: `tel:${CONTACT.PHONE}`,
};

export default ROUTES;
